// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed","518":"preview-api","826":"text","946":"dynamic-content"}[chunkId] + "." + {"180":"b8b820649259c3403eae","303":"b16275901053d404715f","495":"d1381a1c3b041245243f","518":"6f0d192248bef59cb14d","826":"80c202163a570b47a5a4","946":"586a6fb9dc426dffba5e"}[chunkId] + ".js";
};